import * as t from 'io-ts'; // Atlas (Spec 006/008) shared codecs. One definition, used by both the
// full profile-block and the compact profile-popover, so the shape
// can't drift between the two consumers.

export var TaxonomyTerm = t.type({
  slug: t.string,
  displayName: t.string
});
export var Taxonomy = t.type({
  slug: t.string,
  displayName: t.string
});
export var AdvocateTag = t.type({
  taxonomy: Taxonomy,
  terms: t.array(TaxonomyTerm)
});